import React from "react";
import "./Meal.css";
const Meal = (props) => {
  const {
    idMeal,
    strMeal,
    strArea,
    strCategory,
    strInstructions,
    strMealThumb,
  } = props.meal;
  return (
    <div className="popup p-4 rounded-md bg-white dark:bg-slate-800 dark:text-white shadow-sm dark:shadow-black">
      <img src={strMealThumb} className="w-full rounded-md" alt="" />
      <div className="">
        <h2 className="text-xl mt-6">{strMeal}</h2>
        <p className=" text-lg  font-semibold text-teal-600 ">{strCategory}</p>
        <strong>{strArea}</strong>
        <p className="border-l-4 pl-2 mt-2 border-teal-600">
          {strInstructions.slice(0, 250)}
        </p>
      </div>
    </div>
  );
};

export default Meal;
